import { Locale } from '@global/locale/Locale'

import links from '../app/consts/links.json'

export const getTradingViewPromotionUrl = (locale: Locale): string => {
  const baseUrl = links.base_url

  return `${baseUrl}/${locale}/promotions/tradingview-free-subscriptions`
}
